export const DATABASE_NAME = "MyDatabase";
export const STORE_NAME = "myStore";
